<main class="container">

    <div class="modal fade" id="exampleModal" data-bs-keyboard="false" data-bs-backdrop="static">

        <div class="modal-dialog modal-dialog-centered">

            <div class="modal-content">

                <div class="modal-header">

                    <h2 *ngIf="!bLoginMode" class="modal-title" id="exampleModalLabel">ثبت نام</h2>
                    <h2 *ngIf="bLoginMode" class="modal-title" id="exampleModalLabel"> ورود به حساب کاربری </h2>

                    <button type="button" class="btn" (click)="closeSignUp_Modal()">

                        <mat-icon class="mat-18">close</mat-icon>

                    </button>

                </div>

                <form [formGroup]="signUpModel" class="modal-body">

                    <h2> {{!bSendOtp ? ' اطلاعات خود را وارد کنید ' : ' کد تأیید را وارد کنید '}}</h2>

                    <!-- ثبت نام -->

                    <span *ngIf="!bLoginMode">

                        {{!bSendOtp ?

                        ' جهت دسترسی به تمامی امکانات دیار و ثبت آگهی، لازم است که در آن ثبت نام کنید .' :

                        ' کد پیامک شده به شماره ' + (signUpModel.get('strMobile')?.value | faNum ) + ' را وارد کنید '

                        }}

                        <!-- برگشت به فرم ثبت نام -->

                        <span id="changeNumber-btn" class="change-number" *ngIf="bSendOtp && !isFromLoginForm" (click)="bSendOtp = false; bLoginMode = false;
                        
                        signUpModel.get('strMobile')?.enable()"> تغییر شماره </span>

                        <!-- برگشت به فرم لاگین -->

                        <span id="changeNumber-btn" class="change-number" *ngIf="bSendOtp && isFromLoginForm" (click)="bLoginMode = true; bSendOtp = false; isFromLoginForm = false;
                        
                        signUpModel.get('strMobile')?.enable()"> تغییر شماره </span>

                    </span>

                    <!-- بررسی شماره موبایل -->

                    <span *ngIf="bLoginMode"> لطفا شماره موبایل خود را وارد کنید </span>

                    <div class="form-group has-icon">

                        <span class="form-control-icon">

                            <mat-icon class="mat-18">phone_iphone</mat-icon>

                        </span>

                        <input class="mt-4 w-100 form-control" #strMobile formControlName="strMobile"
                            [ngStyle]="{ direction: strMobile.value.trim() == '' ? 'rtl' : 'ltr' }"
                            [placeholder]="strMobile.value.trim() == '' ? ' * شماره موبایل ' : '' "
                            (input)="filterNumericInput($event)" maxlength="11" inputmode="numeric">

                    </div>

                    <ng-container *ngIf="!bSendOtp && bLoginMode">

                        <div class="captcha-area col-12 mt-2">

                            <button type="button" tabindex="-1" class="reload-btn" (click)="get_Captcha()">

                                <i class="fa fa-refresh" aria-hidden="true"></i>

                            </button>

                            <div class="captcha-img">

                                <img src="../../../assets/imgs/captcha-bg.png" alt="">

                                <span class="captcha">{{captcha?.strCaptcha}}</span>

                            </div>
                        </div>

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18"> sms </mat-icon>

                            </span>

                            <input type="text" class="w-100 my-3 form-control" #strOtp
                                [ngStyle]="{ direction: strOtp.value.trim() == '' ? 'rtl' : 'ltr' }"
                                [placeholder]="strOtp.value.trim() == '' ? ' کد امنیتی  ' : '' "
                                (input)="filterNumericInput($event)" maxlength="4" inputmode="numeric"
                                formControlName="strCaptcha">


                        </div>

                    </ng-container>

                    <div *ngIf="!bSendOtp && bLoginMode" class="d-flex mt-2">

                        <input (change)="checkRules($event)" formControlName="rules" type="checkbox" required>
                        <label class="px-1">
                            <a class="pointer" (click)="openAdd()">قوانین و مقررات</a> را مطالعه کرده و با آنها موافقم
                        </label>
                    </div>

                    <ng-container *ngIf="!bSendOtp && !bLoginMode">

                        <!-- <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18"> alternate_email </mat-icon>

                            </span>

                            <input type="text" class="w-100 my-3 form-control" #strEmail
                                [ngStyle]="{ direction: strEmail.value.trim() == '' ? 'rtl' : 'ltr' }"
                                [placeholder]="strEmail.value.trim() == '' ? ' ایمیل ' : '' "
                                formControlName="strEmail">


                        </div> -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">badge</mat-icon>

                            </span>

                            <input type="text" class="w-100 my-3 form-control" formControlName="strName"
                                placeholder="نام">


                        </div>

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">badge</mat-icon>

                            </span>

                            <input type="text" class="w-100 my-3 form-control" formControlName="strFamily"
                                placeholder="* نام خانوادگی">

                        </div>

                        <div class="d-flex flex-column justify-content-between w-100 mb-2 px-2">
                            <div class="central justify-content-start my-1">
                                <input class="mx-2" type="radio" formControlName="tiSex" [value]="1">
                                <mat-icon>man</mat-icon>
                                مرد
                            </div>
                            <div class="central justify-content-start my-1">
                                <input class="mx-2" type="radio" formControlName="tiSex" [value]="2">
                                <mat-icon>woman</mat-icon>
                                زن
                            </div>
                        </div>

                        <div *ngIf="!bSendOtp && !bLoginMode" class="d-flex">

                            <input (change)="checkRules($event)" formControlName="rules" type="checkbox" required>
                            <label class="px-1">
                                <a class="pointer" (click)="openAdd()">قوانین و مقررات</a> را مطالعه کرده و با آنها
                                موافقم
                            </label>
                        </div>

                    </ng-container>

                    <ng-container *ngIf="bSendOtp && !bLoginMode">

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18"> sms </mat-icon>

                            </span>

                            <input type="text" class="w-100 my-3 form-control" #strOtp
                                [ngStyle]="{ direction: strOtp.value.trim() == '' ? 'rtl' : 'ltr' }"
                                [placeholder]="strOtp.value.trim() == '' ? ' کد تایید ' : '' "
                                (input)="filterNumericInput($event)" inputmode="numeric" maxlength="4"
                                formControlName="iOTP">


                        </div>

                    </ng-container>

                </form>

                <div class="modal-footer d-flex flex-row-reverse justify-content-start">

                    <button type="button" class="btn btn-primary px-4" (click)="bLoginMode ? login_User() :
                        
                        !bSendOtp && !bLoginMode ?  signUp_User() :
                        
                        bSendOtp && !bLoginMode ? check_Otp() : '' " [disabled]="((bSendOtp && !bLoginMode) && this.signUpModel.get('iOTP')?.value == '') ||

                        ((bSendOtp && !bLoginMode) && this.signUpModel.get('iOTP')?.value?.length < 4) ||

                        ((!bSendOtp && bLoginMode) && this.signUpModel.get('strMobile')?.value == '') ||

                        ((!bSendOtp && bLoginMode ) && this.signUpModel.get('strMobile')?.value?.length < 10 ) ||

                        ((!bSendOtp && bLoginMode ) && !rulesRead ) ||

                        (!bSendOtp && !bLoginMode) && !rulesRead">

                        {{!bSendOtp && !bLoginMode ? ' ثبت نام ' : ' تایید '}}

                        <!-- تایید -->

                    </button>

                    <button *ngIf="bSendOtp && !bLoginMode" [disabled]=" otpTimer != 0 " (click)="sendAgain_Otp()"
                        type="button" class="btn btn-outline-dark px-4">

                        درخواست مجدد

                        <span *ngIf="otpTimer !=0 " class="me-1">{{ otpTimer | faNum }} </span>

                    </button>

                </div>

            </div>

        </div>

    </div>

    <div class="modal fade" id="exampleModal" data-bs-keyboard="false" data-bs-backdrop="static">

        <div class="modal-dialog modal-dialog-centered">

            <div class="modal-content">

                <div class="modal-header">

                    <h2 *ngIf="!bLoginMode" class="modal-title" id="exampleModalLabel">ثبت نام</h2>
                    <h2 *ngIf="bLoginMode" class="modal-title" id="exampleModalLabel"> ورود به حساب کاربری </h2>

                    <button type="button" class="btn" (click)="closeSignUp_Modal()">

                        <mat-icon class="mat-18">close</mat-icon>

                    </button>

                </div>

                <form [formGroup]="signUpModel" class="modal-body">

                    <h2> {{!bSendOtp ? ' اطلاعات خود را وارد کنید ' : ' کد تأیید را وارد کنید '}}</h2>

                    <!-- ثبت نام -->

                    <span *ngIf="!bLoginMode">

                        {{!bSendOtp ?

                        ' برای استفاده از تمام امکانات دیار ، لطفاً اطلاعات خود را وارد کنید .' :

                        ' کد پیامک شده به شماره ' + (signUpModel.get('strMobile')?.value | faNum ) + ' را وارد کنید '

                        }}

                        <!-- برگشت به فرم ثبت نام -->

                        <span id="changeNumber-btn" class="change-number" *ngIf="bSendOtp && !isFromLoginForm" (click)="bSendOtp = false; bLoginMode = false;
                        
                        signUpModel.get('strMobile')?.enable()"> تغییر شماره </span>

                        <!-- برگشت به فرم لاگین -->

                        <span id="changeNumber-btn" class="change-number" *ngIf="bSendOtp && isFromLoginForm" (click)="bLoginMode = true; bSendOtp = false; isFromLoginForm = false;
                        
                        signUpModel.get('strMobile')?.enable()"> تغییر شماره </span>

                    </span>

                    <!-- بررسی شماره موبایل -->

                    <span *ngIf="bLoginMode"> لطفا شماره موبایل خود را وارد کنید </span>

                    <div class="form-group has-icon">

                        <span class="form-control-icon">

                            <mat-icon class="mat-18">phone_iphone</mat-icon>

                        </span>

                        <input class="mt-4 w-100 form-control" #strMobile formControlName="strMobile"
                            [ngStyle]="{ direction: strMobile.value.trim() == '' ? 'rtl' : 'ltr' }"
                            [placeholder]="strMobile.value.trim() == '' ? ' * شماره موبایل ' : '' "
                            (input)="filterNumericInput($event)" inputmode="numeric" maxlength="11" type="text">

                    </div>

                    <ng-container *ngIf="!bSendOtp && !bLoginMode">

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18"> alternate_email </mat-icon>

                            </span>

                            <input type="text" class="w-100 my-3 form-control" #strEmail
                                [ngStyle]="{ direction: strEmail.value.trim() == '' ? 'rtl' : 'ltr' }"
                                [placeholder]="strEmail.value.trim() == '' ? ' ایمیل ' : '' "
                                formControlName="strEmail">


                        </div>

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">badge</mat-icon>

                            </span>

                            <input type="text" class="w-100 my-3 form-control" formControlName="strName"
                                placeholder="نام">


                        </div>

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">badge</mat-icon>

                            </span>

                            <input type="text" class="w-100 my-3 form-control" formControlName="strFamily"
                                placeholder="* نام خانوادگی">

                        </div>

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">apartment</mat-icon>

                            </span>

                            <select class="w-100 mb-3" formControlName="strCityCode">

                                <option value="-1"> * شهر </option>

                                <option *ngFor="let item of list_City" [value]="item?.CityCode.trim()">
                                    {{item.strCityName}}</option>

                            </select>

                        </div>

                    </ng-container>

                    <ng-container *ngIf="bSendOtp && !bLoginMode">

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18"> sms </mat-icon>

                            </span>

                            <input type="text" class="w-100 my-3 form-control" #strOtp
                                [ngStyle]="{ direction: strOtp.value.trim() == '' ? 'rtl' : 'ltr' }"
                                [placeholder]="strOtp.value.trim() == '' ? ' کد تایید ' : '' "
                                (input)="filterNumericInput($event)" inputmode="numeric" maxlength="4"
                                formControlName="iOTP">


                        </div>

                    </ng-container>

                </form>

                <div class="modal-footer d-flex flex-row-reverse justify-content-start">

                    <button type="button" class="btn px-4" (click)="bLoginMode ? login_User() :
                        
                        !bSendOtp && !bLoginMode ?  signUp_User() :
                        
                        bSendOtp && !bLoginMode ? check_Otp() : '' " [disabled]="((bSendOtp && !bLoginMode) && this.signUpModel.get('iOTP')?.value == '') ||

                        ((bSendOtp && !bLoginMode) && this.signUpModel.get('iOTP')?.value?.length < 4) ||

                        ((!bSendOtp && bLoginMode) && this.signUpModel.get('strMobile')?.value == '') ||

                        ((!bSendOtp && bLoginMode) && this.signUpModel.get('strMobile')?.value?.length < 10 )">

                        تایید2

                    </button>

                    <button *ngIf="bSendOtp && !bLoginMode" [disabled]=" otpTimer != 0 " (click)="sendAgain_Otp()"
                        type="button" class="btn btn-outline-dark px-4">

                        درخواست مجدد

                        <span *ngIf="otpTimer !=0 " class="me-1">{{ otpTimer | faNum }} </span>

                    </button>

                </div>

            </div>

        </div>

    </div>

    <!-- <div class="modal fade" id="imgModal" data-bs-keyboard="false" data-bs-backdrop="static">

        <div style="max-width: inherit !important;width: 90%;" class="modal-dialog modal-dialog-centered">

            <div style="height: 100%;background-color:#000000cf ;" class="modal-content">

                <div class="modal-header border-0">


                    <button type="button" class="btn btn-danger central" (click)="closeImgModal()">

                        <mat-icon class="mat-18">close</mat-icon>

                    </button>

                </div>

                <div class="modal-body central">
                    <img [src]=mainImage_ads alt="تصویر آگهی دیار">
                </div>
            </div>

        </div>

    </div> -->


</main>

<!-- <div class="modal fade" id="full-gallery" data-bs-keyboard="false" data-bs-backdrop="static">

    <div [style]="fullscreen_ModalStyle" class="modal-dialog modal-dialog-centered">

        <div style="height: 100%;background-color:#000000cf ;" class="modal-content">

            <div class="modal-header border-0">

                <button type="button" class="btn btn-danger central" (click)="closeImgModal()">

                    <mat-icon class="mat-18">close</mat-icon>

                </button>

            </div>

            <div class="position-relative modal-body central">

                <img  src="{{current_Image?.strImage}}">


                <span *ngIf="list_AdsImages?.length > 1" class="album-btn next-btn" (click)="next_Image()">

                    <mat-icon class="mat-18">arrow_forward_ios</mat-icon>

                </span>

                <span *ngIf="list_AdsImages?.length > 1" class="album-btn prev-btn" (click)="prev_Image()">

                    <mat-icon class="mat-18">arrow_back_ios_new</mat-icon>

                </span>

                <div *ngIf="list_AdsImages?.length > 1" class="image-description text-center w-100 p-2">

                    <span>{{current_Image?.counter}} از {{list_AdsImages?.length}}  </span>   

                </div>

                <div *ngIf="current_Image?.strComment?.trim() != '' " class="image-description text-center w-100 p-2">

                    <span id="span" (click)="showComplete_Text()">{{current_Image?.strComment}}</span>

                </div>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="alert" data-bs-keyboard="false" data-bs-backdrop="static">

    <div [style]="fullscreen_ModalStyle" class="modal-dialog modal-dialog-centered">

        <div style="height: 100%;background-color:#000000cf ;" class="modal-content">

            <div class="modal-header border-0">

                <button type="button" class="btn btn-danger central" (click)="closeImgModal()">

                    <mat-icon class="mat-18">close</mat-icon>

                </button>

            </div>


            <div class="position-relative modal-body central">
            </div>
        </div>

    </div>

</div>

<div class="modal  fade dir " id="openAds" tabindex="4" role="dialog" aria-hidden="true">
    <div style="width:90%;" class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content bg-gray-soft">
            <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">

            </div>
            <div class="modal-footer  d-flex justify-content-start">

            </div>
        </div>

    </div>

</div> -->